import { render, staticRenderFns } from "./FooterColumnLink.vue?vue&type=template&id=08d679ca&lang=pug&"
import script from "./FooterColumnLink.vue?vue&type=script&lang=js&"
export * from "./FooterColumnLink.vue?vue&type=script&lang=js&"
import style0 from "./FooterColumnLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d679ca')) {
      api.createRecord('08d679ca', component.options)
    } else {
      api.reload('08d679ca', component.options)
    }
    module.hot.accept("./FooterColumnLink.vue?vue&type=template&id=08d679ca&lang=pug&", function () {
      api.rerender('08d679ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FooterColumnLink.vue"
export default component.exports